import React, { Component } from "react";
import { withRouter } from "../../hoc/withRouter";
import { config } from "../../config/GeneralConfig";
import { Form, Select } from "antd";

const { Option } = Select;

class SelectStatusProgressive extends Component {
  render() {
    const { opt_progressive } = config;
    return (
      <Form.Item label="Status Progresif">
        <Select style={{ fontSize: "85%" }} placeholder="Select Data" defaultValue={this.props.value} onChange={this.props.onChangeValue}>
          {Object.keys(opt_progressive).map((s) => {
            return (
              <Option key={opt_progressive[s]} value={opt_progressive[s]}>
                {opt_progressive[s]}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
    );
  }
}

export default withRouter(SelectStatusProgressive);
